import request from '@/utils/request'

const wordURL = {
  Created: '/forbidden-words/create',
  Detail: '/forbidden-words/view',
  List: '/forbidden-words/list',
  Delete: '/forbidden-words/delete',
  Update: '/forbidden-words/update',
  Import: '/forbidden-words/import',
  Export: '/public/forbidden-words/export'
}

// 创建违禁词
export function createWord (data) {
  return request({
    url: wordURL.Created,
    method: 'post',
    data
  })
}

// 违禁词列表
export function listWord (data) {
  return request({
    url: wordURL.List,
    method: 'post',
    data
  })
}

// 违禁词详情
export function detaileWord (data) {
  return request({
    url: wordURL.Detail,
    method: 'post',
    data
  })
}

// 更新违禁词
export function updateWord (data) {
  return request({
    url: wordURL.Update,
    method: 'post',
    data
  })
}

// 删除违禁词
export function deleteWord (data) {
  return request({
    url: wordURL.Delete,
    method: 'post',
    data
  })
}

// 批量导入违禁词
export function importWord (data) {
  return request({
    url: wordURL.Import,
    method: 'post',
    data
  })
}

// 导出违禁词模板
export function exportWord (data) {
  return request({
    url: wordURL.Export,
    method: 'post',
    data
  })
}

export default {
  createWord,
  listWord,
  exportWord,
  detaileWord,
  updateWord,
  deleteWord,
  importWord
}
